export var iconStatusSuccess = {
  "children": [{
    "name": "circle",
    "type": "element",
    "value": "",
    "attributes": {
      "cx": "12",
      "cy": "12",
      "r": "6",
      "fill": "#fff"
    },
    "children": []
  }, {
    "name": "path",
    "type": "element",
    "value": "",
    "attributes": {
      "fill": "#12BB00",
      "d": "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m4.78 8.284-5.491 5.492a.75.75 0 0 1-1.061 0L7.47 13.018a.75.75 0 1 1 1.06-1.061l2.228 2.229 4.962-4.962a.75.75 0 1 1 1.06 1.06"
    },
    "children": []
  }],
  "id": "icon-status-success",
  "viewBox": "0 0 24 24"
};